import { useState, useEffect } from 'react'
import Name from '../../assets/name.png'
import Mobile from '../../assets/mobile.png'
import Plus from '../../assets/Plus.png'
import toast from 'react-hot-toast'
import { useGetDetailsQuery, useEditProfileMutation } from '../../store/api/GetProfileDetails'

function ProfileDetails() {
  const [selectedProfilePic, setSelectedProfilePic] = useState(null);

  const { data: response, refetch } = useGetDetailsQuery()
  const [editProfile] = useEditProfileMutation();

  const [formData, setFormData] = useState({
    profile_pic: "",
    firstname: "",
    lastname: "",
    email: "",
    mobile: "",
  })

  // To see the change of fields 
  const [isEdited, setIsEdited] = useState(false)

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setIsEdited(true);
  };

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedProfilePic(file);
    setIsEdited(true);

    // Preview image locally
    const previewUrl = URL.createObjectURL(file);
    setFormData(prev => ({ ...prev, profile_pic: previewUrl }));
  };





  const handleEditProfile = async () => {
    try {
      const formDataToUpload = new FormData();
      formDataToUpload.append("firstname", formData.firstname);
      formDataToUpload.append("lastname", formData.lastname);
      formDataToUpload.append("email", formData.email);
      formDataToUpload.append("mobile", formData.mobile);

      // Only append selectedProfilePic if it exists
      if (selectedProfilePic) {
        formDataToUpload.append("profile_pic", selectedProfilePic);
      }

      const { data, error } = await editProfile(formDataToUpload).unwrap();
      console.log(data, error)


      toast.success("Profile updated successfully");
      refetch();
      setIsEdited(false);
      setSelectedProfilePic(null); // reset after submit
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };




  useEffect(() => {
    if (response && response?.data) {
      const userDetails = response?.data;
      console.log(userDetails.profile_pic, 'pic')
      const profile_pic = userDetails.profile_pic.replace(/([^:]\/)\/+/g, "$1");
      console.log(profile_pic, 'fixzed')
      setFormData({
        profile_pic: profile_pic || "",
        firstname: userDetails.firstname || "",
        lastname: userDetails.lastname || "",
        email: userDetails.email || "",
        mobile: userDetails.mobile || "",
      })
    }
  }, [response?.data])


  return (
    <>
      <div className='flex justify-center'>
        <div className=' max-w-[1000px] w-full'>
          {/* Profile Image */}
          <div className="flex items-center justify-center w-full py-4">
            <div className="shadow-[9.3px_10.46px_64.96px_0px_rgba(0,0,0,0.2)] px-1 py-1 rounded-full">
              <div className="relative flex items-center justify-center w-28 h-28">
                {/* User Image */}
                <img src={formData.profile_pic} alt="User" className="absolute inset-0 m-auto rounded-full w-28 h-28 object-cover" />
                <img src={Plus} alt="plus" className="absolute bottom-0 right-0 cursor-pointer w-7 h-7"
                  onClick={() => document.getElementById("profilePicInput").click()} />

                <input type="file" accept="image/*" id="profilePicInput" className="hidden" onChange={handleProfilePicChange} />
              </div>
            </div>
          </div>

          {/* Name */}
          <h2 className='flex justify-center pb-3 text-base font-semibold font-poppins dark:text-darkText'>{formData.first_name} {formData.last_name}</h2>

          <div className='grid gap-3 px-10 md:gap-10 md:py-4 md:grid-cols-2'>
            {/* First Name */}
            <div className="relative flex flex-col">
              <label className="text-[#000000] font-poppins text-sm dark:text-darkText">First Name<span className='text-sm text-red-600'>*</span></label>
              <div className="relative">
                <div className="absolute flex items-center justify-center p-3 transform -translate-y-1/2 rounded-lg bg-opacityGradient dark:bg-purple-300 left-2 top-1/2"
                >
                  <img src={Name} alt="User" className="w-5 h-5" />

                </div>
                <input type="text" className="border placeholder:text-darkText border-[#452B7A] dark:bg-transparent dark:text-darkText dark:border-borderColor border-opacity-10 rounded-lg w-full py-4 my-1 pl-16 placeholder:font-poppins placeholder:text-sm placeholder:text-[#000000] placeholder:opacity-50 bg-white focus:outline-none focus:ring-1 focus:ring-[#452B7A]"
                  placeholder="Enter First Name"
                  required
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                  value={formData.firstname}
                  onChange={(e) => handleChange("firstname", e.target.value)}

                />
              </div>
            </div>

            {/* Last Name */}
            <div className="relative flex flex-col">
              <label className="text-[#000000] font-poppins text-sm dark:text-darkText">Last Name<span className='text-sm text-red-600'>*</span></label>
              <div className="relative">
                <div className="absolute flex items-center justify-center p-3 transform -translate-y-1/2 rounded-lg bg-opacityGradient dark:bg-purple-300 left-2 top-1/2">
                  {/* style={{background:' linear-gradient(213deg, rgba(108, 71, 183, 0.1) -27.59%, rgba(52, 31, 96, 0.1) 105.15%)'}} */}
                  <img src={Name} alt="User" className="w-5 h-5" />

                </div>
                <input type="text" className="border placeholder:text-darkText border-[#452B7A] dark:bg-purple-300 dark:bg-transparent dark:text-darkText dark:border-borderColor  border-opacity-10 rounded-lg w-full py-4 my-1 pl-16 placeholder:font-poppins placeholder:text-sm placeholder:text-[#000000] placeholder:opacity-50 bg-white focus:outline-none focus:ring-1 focus:ring-[#452B7A]"
                  placeholder="Enter Last Name"
                  required
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                  value={formData.lastname}
                  onChange={(e) => handleChange("lastname", e.target.value)}
                />
              </div>
            </div>

          </div>

          {/* 2nd row */}
          <div className='grid gap-3 px-10 pb-4 md:gap-10 md:grid-cols-2'>
            {/* Email */}
            <div className="relative flex flex-col">
              <label className="text-[#000000] font-poppins text-sm dark:text-darkText">Email<span className='text-sm text-red-600'>*</span></label>
              <div className="relative">
                <div className="absolute flex items-center justify-center p-3 transform -translate-y-1/2 rounded-lg bg-opacityGradient dark:bg-purple-300 left-2 top-1/2">
                  <img src={Name} alt="User" className="w-5 h-5" />

                </div>
                <input type="text" className="border placeholder:text-darkText border-[#452B7A] dark:bg-transparent dark:text-darkText dark:border-borderColor  border-opacity-10 rounded-lg w-full py-4 my-1 pl-16 placeholder:font-poppins placeholder:text-sm placeholder:text-[#000000] placeholder:opacity-50 bg-white focus:outline-none focus:ring-1 focus:ring-[#452B7A]"
                  placeholder="Enter Email"
                  required
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                  value={formData.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                />
              </div>
            </div>

            {/* Mobile Number */}
            <div className="relative flex flex-col">
              <label className="text-[#000000] font-poppins text-sm dark:text-darkText">Mobile Number<span className='text-sm text-red-600'>*</span></label>
              <div className="relative">
                <div className="absolute flex items-center justify-center p-3 transform -translate-y-1/2 rounded-lg bg-opacityGradient dark:bg-purple-300 left-2 top-1/2">

                  <img src={Mobile} alt="User" className="w-5 h-5" />

                </div>
                <input type="text" className="border placeholder:text-darkText border-[#452B7A] dark:bg-transparent dark:text-darkText dark:border-borderColor  border-opacity-10 rounded-lg w-full py-4 my-1 pl-16 placeholder:font-poppins placeholder:text-sm placeholder:text-[#000000] placeholder:opacity-50 bg-white focus:outline-none focus:ring-1 focus:ring-[#452B7A]"
                  placeholder="Enter Mobile Number"
                  required
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                  value={formData.mobile}
                  onChange={(e) => handleChange("mobile", e.target.value)}

                />
              </div>
            </div>
          </div>

          {/* 3rd row */}
          <div className='grid gap-3 px-10 md:gap-10 md:grid-cols-2'>
            {/* DOB */}

            {/* Gender */}
          </div>

          {/* Submit Button */}
          <div className='flex justify-center py-8 '>
            <button className={`text-base font-poppins text-[#FFFFFF] px-16 py-2 rounded-lg ${isEdited ? "bg-button-gradient" : "bg-header bg-opacity-[45%]"}`}
              onClick={handleEditProfile}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProfileDetails